import request from '../../axios/axiosconfig.js'

export function getAllBankCard(params) {
  return request({
    url: '/ps/bankCardManagement/getAllBankCard',
    method: 'get',
    params: params
  })
}


// WEBPACK FOOTER //
// ./src/api/withdraw/bankCardManagement.js